import {useRunWorkflow} from '@/biz/workflow.jsx'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default props => {
    const runWorkflow = useRunWorkflow()
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_DB_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => {
        const {dbCode, prjId, sVer} = map.root.data
        const bizMap = {dbCode, prjId, sVer}
        runWorkflow({bizMap, scene: 'GENERATE_ATCF'})
    }

    return {
        label: '分析技术字段',
        onClick,
        ...props
    }
}
